import { observable, action, runInAction} from 'mobx'
import uuid from 'uuid/v4'
import { message } from 'antd'
import moment from 'moment'
import { json, get } from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class ApprovalStore {

    //constructor***************************************************************************************************** */
    @observable directory
    @observable contents
    @observable catalogSelectId
    @observable loading
    @observable options
    @observable editFields
    @observable modal
    @observable option
    @observable carSeriesId
    @observable pagination
    @observable historyList
    @observable historyModal
    @observable carseries
    @observable carSysId
    @observable rowData

    constructor () {
        this.options = []
        this.directory = []
        this.contents = []
        this.catalogSelectId=''
        this.carSysId = ''
        this.carseries = []
        this.loading=false
        this.editFields = {}
        this.modal = 'hide'
        this.option = [];
        this.carSeriesId = [];
        this.page = {
            current: 0,
            total: 1
        }
        this.historyList = [];
        this.historyModal = 'hide';
        this.rowData = {}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    //Tree
    @action
    initDirectory = async (value) => {
        runInAction(() => {
            this.contents= []
            this.loading=true
            this.carSeriesId =this.carSysId;
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/list?carseriesId=${value}`)
        if(res.length===0){
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.directory = []
                this.loading=false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading=false
        })
    }

    //ShowContent
    @action loadContents = async (directoryId) => {
        runInAction(() => {
            this.loading=true
        })
        if(directoryId.length === 0){
            runInAction(() => {
                this.loading=false;
                // this.contents = [];
            })
            return;
        }
        const result = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/selectLevel?id=` + directoryId.id);
        if(result.data === 4){
            const contents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=` + directoryId.id);
            if (contents.status && contents.status === 0) {
                return
            }
            runInAction(() => {
                this.catalogSelectId = directoryId.id
                this.contents = contents.length ? contents : [{
                        id: `${uuid()}`,
                        image: '',
                        defaultContent: '',
                        type: 1,
                        catalogId: this.catalogSelectId
                    }]
                this.loading=false
            })
        }else{
            runInAction(() => {
                this.loading=false;
                this.contents = [];
            })
        }
    }

    //Save
    @action saveContents = async () => {
        runInAction(() => {
            this.loading = true
        })
        for (let i = 0; i < this.contents.length; i++) {
            let content = this.contents[i]
            if (!content.defaultContent.trim() && !content.image.trim()) {
                message.error('请填写完内容后保存！')
                runInAction(() => {
                    this.loading = false
                })
                return
            }
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/save`,this.contents)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/updateApprovalState/`+this.catalogSelectId+`/1`);

        message.success('保存成功！')
        runInAction(() => {
            this.loading = false
        })
    }

    //响应审批通过按钮
    @action pass = async () => {
        //查询审批状态
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog:approvalState/`+this.catalogSelectId);
        switch(res){
            case 1:
                message.error('内容处于草稿状态，请勿审批！');
                break;
            case 2:
                this.showBox(1);
                break;
            case 3:
                message.error('内容处于审批通过状态，请勿审批！');
                break;
            case 4:
                message.error('内容处于审批驳回状态，请勿审批！');
                break;
            default:
                break;
        }
    }

    //响应审批驳回按钮
    @action reject = async () => {
        //查询审批状态
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog:approvalState/`+this.catalogSelectId);
        switch(res){
            case 1:
                message.error('内容处于草稿状态，请勿审批！');
                break;
            case 2:
                this.showBox(2)
                break;
            case 3:
                message.error('内容处于审批通过状态，请勿审批！');
                break;
            case 4:
                message.error('内容处于审批驳回状态，请勿审批！');
                break;
            default:
                break;
        }
    }

    //重置审批
    @action resetting = async () => {
        const data = {
            "approvalOption": 3,
            "catalogId": this.catalogSelectId
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/approval`, data);
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/updateApprovalState/`+this.catalogSelectId+`/1`);
        message.success('重置成功！');
        this.initDirectory(this.carSeriesId);
        this.loadContents(this.catalogSelectId);
    }


    //Box************************************************************************************************************* */

    //ShowBox
    @action
    showBox = (option) =>{
        runInAction(() => {
            this.loading=true
            this.editFields.content = ""
            this.modal = 'show'
            this.loading=false
            this.option = option
        })
    }

    //Cast
    @action.bound
    onEditFieldChange (changedFields) {
        this.editFields = {...this.editFields, ...changedFields}
    }

    //保存审批意见 && 审批通过/审批驳回
    @action
    operation = async (content) =>{
        //审批通过
        if(this.option === 1){
            const data = {
                "approvalOption": 1,
                "catalogId": this.catalogSelectId,
                "suggestion": content.content
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/approval`, data);
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/updateApprovalState/`+this.catalogSelectId+`/3`);
        }else{
            const data = {
                "approvalOption": 2,
                "catalogId": this.catalogSelectId,
                "suggestion": content.content
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/approval`, data);
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/updateApprovalState/`+this.catalogSelectId+`/4`);
        }
        this.closeBox();
        message.success("审核通过！");
        this.initDirectory(this.carSeriesId);
        this.loadContents(this.catalogSelectId);
    }

    /**
     *取消编辑
     */
    @action.bound
    cancelEdit() {
        this.loading = false
        this.modalSelect = 'hide'
    }
    //HideBox
    @action
    closeBox = () =>{
        this.modal = 'hide'
    }

    //Show Add Lv1 Catalog Box
    @action
    showAddFirstBox = () =>{
        runInAction(() => {
            this.loading=true
            this.editFields.content = ""
            this.modal = 'show'
            this.loading=false
        })
    }

    //History************************************************************************************************************* */

    //Page
    @action
    initHistoryList = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        // 服务器page参数下标从0开始
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/approvals:search`, {
            page,
            catalogId: this.catalogSelectId,
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.historyList = res.content.map(l => {
                return {
                    id: l.id,
                    createTime: moment(l.createTime).format('YYYY-MM-DD HH:mm:ss'),
                    approvedMan: l.approvedMan,
                    approver: l.approver,
                    approvalOption:(l.approvalOption === 0)?"送审":((l.approvalOption === 1)?"审批通过":((l.approvalOption === 2)?"审批驳回":"重置审批")),
                    suggestion: l.suggestion
                }
            })
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                results: res.size,
            }
            this.loading = false
            this.historyModal = 'show'
        })
    }

    @action
    cancelHistory= () =>{
        runInAction(() => {
            this.loading = false
            this.historyModal = 'hide'
        })
    }


    //End************************************************************************************************************* */

    @action changeContentTitle = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (id === item.id) {
                    return {...item, title: value}
                }
                return item
            })
        })
    }

    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: type * 1,
                    catalogId:this.catalogSelectId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    @action setContent = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, defaultContent: value}
                }
                return item
            })
        })
    }

    @action delContent = (id) => {
        const contents = this.contents.filter(item => item.id !== id)
        runInAction(() => {
            this.contents = contents.length > 0 ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    defaultContent: '',
                    type: 1,
                    catalogId:this.catalogSelectId
                }]
        })
    }

    @action delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })

        })

    }

    @action addImage = (id, url) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    @action contentUp = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index - 1)
            })
        }
    }

    @action contentDown = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index >= 0 && index < this.contents.length) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index + 1)
            })
        }
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }

    @action initBrands = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brands:search?size=100`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.options  = res.content.map((item)=>{return({
                value: `${item.id}`,
                label: `${item.defaultName}`,
                isLeaf: false
            })})
        })
    }
    @action initCarseries = async (id) => {

        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries:search`, {
            'size': 100,
            'search.state': '1',
            'search.carBrandId': id
        })

        const options = this.options.map(item => {
            if (item.value === id) {
                return {...item, children: res.content.map(it => {
                    return {
                        value: `${it.id}`,
                        label: `${it.defaultName}`,
                        isLeaf: true
                    }
                })}
            }
            return item
        })
        runInAction(() => {
            this.options = options
        })
    }

    @action emptySelect = () =>{
        runInAction(() => {
                this.brands = {
                    list: [],
                    selected: ''
                }
                this.carSeries = {
                    list: [],
                    selected: ''
                }
            }
        )
    }
    @action empetyDirectory = () => {
        runInAction(() => {
                this.directory = []
            }
        )

    }
    @action empetyContents = () => {
        runInAction(() => {
                this.contents = []
            }
        )
    }

    /**
     * 初始化车系
     */
    @action initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/carseriesCatalogs`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res
            this.loading = false
        })
    }

    /**
     * 取车系ID
     */
    @action getCarSysId = (value) =>{
        runInAction(()=>{
            this.carSysId = value;
        })
    }
}

export default new ApprovalStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/maintain/Approval/store.js